export enum MyDSpaceConfigurationValueType {
  Workspace = 'workspace',
  SupervisedItems = 'supervisedWorkspace',
  OtherWorkspace = 'otherWorkspace',
  Workflow = 'workflow'
}
